import { Button, Col, Form, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText, Modal, ModalBody, ModalHeader, Row } from "reactstrap"
import Error from "./Error"
import { useEffect, useState } from "react"
import { erroInesperado } from "services/Utils"
import { alert } from "./Alert"
import { hideLoading, showLoading } from "./Loading"
import authService from "services/AuthService"

const initialData = { senhaAtual: '', novaSenha: '', confirmacaoSenha: '' }

export default function AlterarSenha({ config, onClose }) {
  const [data, setData] = useState(initialData)
  const [errors, setErrors] = useState([])

  useEffect(() => {
    setData(initialData)
  }, [config])

  const validar = () => {
    const errors = []
    if (!data?.senhaAtual) {
      errors.push({
        fieldName: 'senhaAtual',
        error: 'Campo obrigatório'
      })
    }
    if (!data?.novaSenha) {
      errors.push({
        fieldName: 'novaSenha',
        error: 'Campo obrigatório'
      })
    }
    if (!data?.confirmacaoSenha) {
      errors.push({
        fieldName: 'confirmacaoSenha',
        error: 'Campo obrigatório'
      })
    }
    if (data.novaSenha !== data.confirmacaoSenha) {
      errors.push({
        fieldName: 'confirmacaoSenha',
        error: 'As senhas não conferem'
      })
    }
    setErrors(errors)
    return errors.length === 0
  }

  const handleChange = (field, value) => {
    setData({ ...data, [field]: value })
  }

  const handleSubmit = async (ev) => {
    ev.preventDefault()

    if (validar()) {
      let res = null
      try {
        showLoading()
        res = await authService.alterarSenha(data.senhaAtual, data.novaSenha)
        if (res.success) {
          alert({
            text: 'Sua senha foi alterada com sucesso!',
            onClose: () => {
              onClose && onClose()
            }
          })
        } else {
          alert({
            header: 'Atenção',
            text: 'Dados de acesso inválidos'
          })
        }
        hideLoading()
      } catch (ex) {
        hideLoading()
        if (ex.message == 'Unauthorized') {
          alert({
            header: 'Atenção',
            text: 'Dados de acesso inválidos'
          })
        } else {
          erroInesperado()
        }
      }
    }
  }

  const handleCancelar = () => {
    onClose && onClose()
  }

  return (
    <Modal isOpen={!!config}>
      <ModalHeader>
        Alterar Senha
      </ModalHeader>
      <ModalBody>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <InputGroup className="input-group-alternative">
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="ni ni-lock-circle-open" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                placeholder="Senha atual"
                type="password"
                autoComplete="senhaAtual"
                value={data.senhaAtual}
                onChange={e => handleChange('senhaAtual', e.target.value)}
              />
            </InputGroup>
            <Error errors={errors} fieldName="senhaAtual" className="mt-1" />
          </FormGroup>
          <FormGroup>
            <InputGroup className="input-group-alternative">
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="ni ni-lock-circle-open" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                placeholder="Nova senha"
                type="password"
                autoComplete="novaSenha"
                value={data.novaSenha}
                onChange={e => handleChange('novaSenha', e.target.value)}
              />
            </InputGroup>
            <Error errors={errors} fieldName="novaSenha" className="mt-1" />
          </FormGroup>
          <FormGroup>
            <InputGroup className="input-group-alternative">
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <i className="ni ni-lock-circle-open" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                placeholder="Confirme a nova senha"
                type="password"
                autoComplete="confirmacaoSenha"
                value={data.confirmacaoSenha}
                onChange={e => handleChange('confirmacaoSenha', e.target.value)}
              />
            </InputGroup>
            <Error errors={errors} fieldName="confirmacaoSenha" className="mt-1" />
          </FormGroup>
          <Row className="align-items-center">
            <Col>
              <Button className="my-2" outline color="primary" type="button" onClick={handleCancelar}>
                Cancelar
              </Button>
            </Col>
            <Col className="text-right">
              <Button className="my-2" color="primary" type="submit">
                Alterar a senha
              </Button>
            </Col>
          </Row>
        </Form>
      </ModalBody>
    </Modal>
  )
}